import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit, TemplateRef } from '@angular/core';
import { NgbActiveModal, NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDeleteComponent } from '../../confirm-delete/confirm-delete.component';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { Router } from '@angular/router';
import { licenseFormComponent } from '../license-form/license-form.component';
import { PaginationComponent } from '../../pagination/pagination.component';

@Component({
  selector: 'app-license-list',
  standalone: true,
  imports: [
    CommonModule,
    licenseFormComponent,
    LoaderComponent,
    NgbDropdown,
    NgbDropdownMenu,
    NgbDropdownItem,
    NgbDropdownToggle,
    PaginationComponent
  ],
  templateUrl: './license-list.component.html',
  styleUrl: './license-list.component.scss'
})
export class licenseListComponent implements OnInit {
  @Input() reload: boolean = false;
  @Input() organisationId: string | null = null;
  items: [] = [];
  private modalService = inject(NgbModal);
  loading: boolean = false;
  currentItemId: string = '';

  currentPage: number = 1;
  itemsPerPage: number = 10;

  constructor(
    private router: Router,
    private apiService: ApiService
  ) {
    this.loading = true;
  }

  ngOnInit(): void {
    this.getItems();
  }

  get paginatedItems() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.items.slice(startIndex, endIndex);
  }

  handlePageChange(newPage: number) {
    this.currentPage = newPage;
  }

  ngOnChanges(changes: any) {
    if (this.reload === true) {
      this.getItems();
      this.reload = false;
    }
  }

  openModal(item: any) {
    let self = this;
    const modalRef = this.modalService.open(licenseFormComponent);
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.item = item;
    modalRef.componentInstance.organisationId = this.organisationId;
    modalRef.componentInstance.modalInstance = modalRef;
    modalRef.result.then((result) => {
      self.getItems();
    });
  }

  delete(item: any) {
    let self = this;
    self.loading = false;
    const deleteModal = this.modalService.open(ConfirmDeleteComponent);
    deleteModal.componentInstance.message = 'Weet je zeker dat je wilt verwijderen?';
    deleteModal.result.then((result) => {
      if (result) {
        let self = this;
        return this.apiService.delete('/office/licenses/' + item['id']).then(function (response: any) {
          setTimeout(function () { self.getItems(); }, 200);
          return true;
        }).catch(function (e) {
          self.getItems();
          return true;
        });
      } else {
        return true;
      }
    });
  }

  getItems() {
    let self = this;
    if (this.organisationId) {
      return this.apiService.get('/office/organisations/' + this.organisationId + '/licenses').then(function (response: any) {
        self.items = response['data'];
        setTimeout(function () { self.loading = false; }, 200);
        self.reload = false;
      }).catch(function (e) {
        self.loading = false;
      });
    } else {
      return this.apiService.get('/office/licenses').then(function (response: any) {
        self.items = response['data'];
        setTimeout(function () { self.loading = false; }, 200);
        self.reload = false;
      }).catch(function (e) {
        self.loading = false;
      });
    }
  }
}
